<template>
  <!-- Section end -->
  <div
    class="tab-pane fade"
    id="nav-direct-debits"
    role="tabpanel"
    aria-label="nav-direct-debits-tab"
  >
    <div class="container-fluid" v-if="customer && account">
      <div class="row mt-3">
        <div class="col-12 my-auto">
          <div class="row">
            <div class="col-12 my-auto">
              <h5 class="d-inline">Bank Details</h5>
              <a class="btn btn-hc-nb pointer">
                <img
                  src="@/assets/img/add_icon_hcg.png"
                  class="pl-2 d-inline-block"
                  alt="Add Icon"
                  data-toggle="modal"
                  data-target="#addBankAccount"
                />
              </a>
            </div>
          </div>

          <hr class="mt-1" />

          <div class="row">
            <div class="col-12 table-div mt-3 pl-3 pr-3">
              <b-table
                v-if="bankDetails && bankDetails.length > 0"
                id="bank_details_table"
                class="table-scroll tbl-sml"
                striped
                text-center
                :items="bankDetails"
                :fields="bankFields"
              >
                <template slot="BankId" slot-scope="data">
                  <div class="bank_logo mx-auto">
                    <img
                      v-if="data.item.BankId === undefined"
                      :src="'https://rbdata.blob.core.windows.net/bank-logos/UNKNOWN.jpg'"
                      :alt="data.item.BankId"
                      class="img-fluid bi border border-secondary"
                    />
                    <img
                      v-else
                      :src="'https://rbdata.blob.core.windows.net/bank-logos/' + data.item.BankId + '.jpg'"
                      :alt="data.item.BankId"
                      class="img-fluid bi border border-secondary"
                    />
                    <img
                      v-if="!data.item.EffectiveTo"
                      src="@/assets/img/tick_selector.png"
                      class="img-fluid position-absolute tick"
                      alt="Active account icon"
                    />
                  </div>
                </template>
                <template slot="Details" slot-scope="data">
                  <p class="mb-0 fwfont my-auto">{{data.item.MaskedSortCode}}</p>
                  <p class="fwfont my-auto">{{data.item.MaskedAccountNumber}}</p>
                </template>
                <template slot="Reference" slot-scope="data">
                  <!-- Below if statment may be unnecessary -->
                  <span v-if="data.item.hasOwnProperty('DdOrganisationId')">
                    <img
                      v-if="data.item.DdOrganisationId === 1"
                      src="@/assets/img/electricity_icon.png"
                      class="img-fit_inline"
                      alt="Electricity icon"
                    />
                    <img
                      v-if="data.item.DdOrganisationId === 2"
                      src="@/assets/img/gas_icon.png"
                      class="img-fit_inline"
                      alt="Gas icon"
                    />
                  </span>
                  {{data.item.Reference}}
                </template>
                <template slot="AccountName" slot-scope="data">{{data.item.AccountName}}</template>
                <template slot="DatesEffective" slot-scope="data">
                  <p class="my-auto">{{data.item.EffectiveFrom | moment("DD.MM.YY")}}</p>
                  <p class="my-auto mb-0 mt--20">To:</p>
                  <p
                    class="my-auto"
                    v-if="data.item.EffectiveTo != null"
                  >{{data.item.EffectiveTo | moment("DD.MM.YY")}}</p>
                  <p v-else class="mb-0 font-weight-bold">Current</p>
                </template>
                <template slot="Status" slot-scope="data">
                  <div v-if="!data.item.EffectiveTo">
                    <a
                      href="#"
                      class="d-block bb link"
                      data-toggle="modal"
                      data-target="#EndBankAccount"
                      @click="rowClicked(data.item)"
                    >End Account</a>
                  </div>
                </template>
              </b-table>
              <div v-else-if="bankDetails.length === 0 && customer.BankDetails && customer.BankDetails.length > 0" class="h-100">
                <div class="d-flex h-100 justify-content-center align-items-center">
                  <img
                    src="@/assets/img/tick_selector.png"
                    class="img-fluid d-inline-block"
                    alt="No debt greater than 30 days"
                  />
                  <p class="d-inline-block my-auto pl-2">
                    Bank details have been received for the customer and will be
                    lodged
                    soon
                  </p>
                </div>
              </div>
              <div v-else class="h-100">
                <div class="d-flex h-100 justify-content-center align-items-center">
                  <img
                    src="@/assets/img/cross.png"
                    class="img-fluid d-inline-block"
                    alt="No debt greater than 30 days"
                  />
                  <p
                    class="d-inline-block my-auto pl-2"
                  >Bank details have not been received for the customer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 my-auto">
          <div class="row">
            <div class="col-12 my-auto">
              <h5 class="d-inline">Fixed Payment Instructions</h5>
              <a
                v-if="((bankDetails && bankDetails.length > 0 && hasActiveBankDetails) || (bankDetails.length == 0 && customer.BankDetailsId)) && account.CollectionMethod == 'DDFIX'"
                class="btn btn-hc-nb pointer"
                role="button"
                data-toggle="modal"
                data-target="#addFixedPayment"
              >
                <img
                  src="@/assets/img/add_icon_hcg.png"
                  class="pl-2 d-inline-block"
                  alt="Add Icon"
                  data-toggle="modal"
                  data-target="#addFixedPayment"
                />
              </a>
              <div class="float-right">
                <div class="d-flex w-100 justify-content-center align-self-center">
                  <i
                    class="float-right pointer fas fa-eye mt-3 mx-2"
                    data-toggle="modal"
                    data-target="#viewFixedPayments"
                    v-if="fixedPayments.length > 0"
                  ></i>
                  <i
                    class="float-right pointer fas fa-edit mt-3 mx-2"
                    v-if="displayEditFixedPaymentInstructionButton"
                    @click="toggleEditMode(true)"
                  ></i>
                </div>
              </div>
            </div>
          </div>

          <hr class="mt-1" />

          <!-- If there IS a fixed payment amount set up display this start -->
          <div v-if="currentFixedPayment">
            <div class="row">
              <div class="col-6">
                <p class="font-weight-bold">Payment Amount:</p>
              </div>
              <div class="col-6">
                <p
                  v-if="!this.editMode"
                >{{currentFixedPayment.RegularCollectionAmount | currency()}}</p>
                <div v-if="this.editMode" class="input-group-prefix prefix w-100">
                  <p
                    type="number"
                    step=".01"
                    class="z-depth-1 prefix"
                    id="regularPaymentInput"
                    placeholder="Eg: 10.00"
                  >{{currentFixedPayment.RegularCollectionAmount | currency()}}</p>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-6 mt--20">
                <p class="font-weight-bold">Collection Days(s):</p>
              </div>
              <div class="col-6 mt--20">
                <div>
                  <p
                    class="d-inline"
                    v-for="(day, index) in currentFixedPayment.DaysOfMonth"
                    :key="index"
                  >
                    {{day | daySuffix()}}
                    <span
                      v-if="index <  currentFixedPayment.DaysOfMonth.length - 2"
                    >,</span>
                    <span v-if="index == currentFixedPayment.DaysOfMonth.length - 2">&</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-6 mt--20">
                <p class="font-weight-bold">Next Collection Due:</p>
              </div>
              <div class="col-6 mt--20">
                <p>{{currentFixedPayment.NextCollectionDue | moment('Do MMM YYYY')}}</p>
              </div>
            </div>

            <div v-if="displayEffectiveTo" class="row mt-3">
              <div class="col-6 mt--20">
                <p class="font-weight-bold">Effective To:</p>
              </div>
              <div class="col-6 mt--20">
                <div v-if="!this.editMode">
                  <p
                    v-if="this.currentFixedPayment.hasOwnProperty('EffectiveTo')"
                  >{{currentFixedPayment.EffectiveTo | moment('Do MMM YYYY')}}</p>
                </div>

                <el-date-picker
                  v-if="this.editMode"
                  placeholder="Effective To"
                  v-model="effectiveTo"
                  format="dd.MM.yyyy"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :picker-options="effectiveToOptions"
                />
              </div>
            </div>

            <hr class="mt-1" />

            <div class="row" v-if="editMode">
              <div class="col-12 my-auto">
                <div class="float-right">
                  <div class="d-flex w-100 justify-content-center align-self-center">
                    <b-btn class="float-right btn btn-hc mx-2" @click="toggleEditMode(false)">Cancel</b-btn>
                    <b-btn
                      class="float-right btn btn-hc mx-2"
                      @click="updateFixedPayment()"
                    >Save Changes</b-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- If there IS a fixed payment amount set up display this end -->

          <!-- If there isn't a fixed payment amount set up display this start -->
          <div class="row" v-if="!currentFixedPayment">
            <div class="col-12">
              <div class="h-100">
                <div class="d-flex h-100 justify-content-center align-items-center">
                  <img
                    src="@/assets/img/warning_icon.png"
                    class="img-fluid d-inline-block"
                    alt="Warning"
                  />
                  <p class="d-inline-block my-auto pl-2">
                    There are no current fixed payment instructions for this
                    account.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- If there isn't a fixed payment amount set up display this end -->
        </div>
      </div>

      <!-- End -->
    </div>
    <!-- container fluid close -->
  </div>
  <!-- tab pane close -->
</template>

<script>
import moment from 'moment';
import { _ } from 'vue-underscore';
import Vue from 'vue';
import _filters from '@/mixins/filters.js';

export default {
	mixins: [_filters],
	data() {
		return {
			effectiveTo: null,
			effectiveToOptions: {
				disabledDate: (date) => {
					return date < moment(this.currentFixedPayment.FirstCollectionDue);
				},
			},
			bankFields: {
				BankId: {
					label: 'Bank',
					sortable: true,
					class: 'text-center my-auto col-2',
				},
				Details: {
					label: 'Details',
					class: 'text-center fwfont my-auto col-2',
				},
				Reference: {
					label: 'Reference',
					class: 'text-center fwfont my-auto col-2',
				},
				AccountName: {
					label: 'Account Name',
					class: 'text-center my-auto col-2',
				},
				DatesEffective: {
					label: 'Dates Effective',
					class: 'text-center my-auto col-2',
				},
				Status: {
					label: 'Status',
					class: 'text-center my-auto clickable_link col-2',
				},
			},
		};
	},
	computed: {
		customer: {
			get() {
				return this.$store.state.customers.customer;
			},
			set(customer) {
				this.$store.commit('updateCustomer', customer);
			},
		},
		account() {
			return this.$store.state.customers.account;
		},
		fixedPayments: {
			get() {
				return this.$store.state.finances.fixedPayments;
			},
			set(fixedPayments) {
				this.$store.commit('updateFixedPayments', fixedPayments);
			},
		},
		editMode: {
			get() {
				return this.$store.state.finances.fixedPaymentEditMode;
			},
			set(bool) {
				this.$store.commit('updateFixedPaymentEditMode', bool);
			},
		},
		budgetBotInfo() {
			return this.$store.state.customers.budgetBotInfo;
		},
		currentFixedPayment() {
			return _.find(
				_.sortBy(this.fixedPayments, 'FirstCollectionDue').reverse(),
				function(fp) {
					return (
						!fp.hasOwnProperty('EffectiveTo') ||
						moment(moment().format('YYYY-MM-DD')).isSameOrBefore(
							moment.utc(fp.EffectiveTo).format()
						)
					);
				}
			);
		},
		bacsCalendar() {
			return this.$store.state.finances.bacsCalendar;
		},
		nextCollectionDate() {
			if (this.bacsCalendar) {
				if (this.bacsCalendar.BacsDay) {
					return this.bacsCalendar.RequestedDate;
				}
				return this.bacsCalendar.NextBacsDay;
			}
			return null;
		},
		bankDetails() {
			return _.sortBy(
				this.$store.state.finances.bankDetails,
				'EffectiveFrom'
			).reverse();
		},
		hasActiveBankDetails() {
			return _.find(this.bankDetails, function(details) {
				return (
					!details.hasOwnProperty('EffectiveTo') || details.EffectiveTo == null
				);
			});
		},
		displayEditFixedPaymentInstructionButton() {
			return (
				this.currentFixedPayment &&
				!this.editMode &&
				!['DUAL', 'SEBL'].includes(this.$config.honeycomb.supplierId)
			);
		},
		displayEffectiveTo() {
			return !['DUAL', 'SEBL'].includes(this.$config.honeycomb.supplierId);
		},
		// bankDetailsId() {
		//   return this.$store.state.customers.customer.BankDetailsId
		// }
	},
	methods: {
		showModal() {
			let element = this.$refs.modal.$el;
			$(element).EndBankAccount('show');
		},
		rowClicked(item) {
			this.$store.commit('updateEndBankAccount', item);
		},
		toggleEditMode(bool) {
			if (bool) {
				this.beforeEditingFixedPayment = Object.assign(
					{},
					this.currentFixedPayment
				);
				this.$store.commit('updateBacsCalendar', null);
				this.$store.dispatch(
					'getBacsCalendar',
					this.currentFixedPayment.NextCollectionDue
				);
				if (this.currentFixedPayment.hasOwnProperty('EffectiveTo')) {
					this.effectiveTo = this.currentFixedPayment.EffectiveTo;
				}
			}
			if (!bool) {
				Object.assign(this.currentFixedPayment, this.beforeEditingFixedPayment);
				this.effectiveTo = null;
			}
			this.editMode = bool;
		},
		daysOfMonth() {
			var arr = Array(31);
			for (let index = 0; index < arr.length; index++) {
				arr[index] = index + 1;
			}
			return arr;
		},
		updateFixedPayment() {
			this.submitStatus = 'PENDING';
			this.$http
				.put(
					'https://' +
						Vue.config.honeycomb.ddbot.domain +
						'/api/v1/fixed-payments/' +
						this.currentFixedPayment.Id,
					{
						Id: this.currentFixedPayment.Id,
						AccountId: this.currentFixedPayment.AccountId,
						DaysOfMonth: this.currentFixedPayment.DaysOfMonth.sort(
							(a, b) => a - b
						),
						FirstCollectionDue: this.currentFixedPayment.FirstCollectionDue,
						FirstCollectionAmount: this.currentFixedPayment
							.FirstCollectionAmount,
						RegularCollectionAmount: parseFloat(
							this.currentFixedPayment.RegularCollectionAmount
						).toFixed(2),
						NextCollectionDue: !this.nextCollectionDate
							? this.currentFixedPayment.NextCollectionDue
							: moment.utc(this.nextCollectionDate).format(),
						EffectiveTo: this.effectiveTo
							? moment.utc(this.effectiveTo).format()
							: undefined,
					},
					{
						withCredentials: true,
					}
				)
				.then(() => {
					this.submitStatus = 'OK';
					this.$snotify.success('Success! Direct debit updated.');
					this.$store.dispatch('getFixedPayments');
					this.editMode = false;
					this.effectiveTo = null;
				})
				.catch((error) => {
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// this.submitStatus = 'Error'
						if (error.response.data.MoreInformation.length > 0) {
							error.response.data.MoreInformation.forEach((e) => {
								this.$snotify.error(`${e.Error}`, {
									timeout: 0,
									closeOnClick: true,
								});
							});
						} else {
							this.$snotify.error(`${error.response.data.UserDescription}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						// this.submitStatus = 'Error'
						this.$snotify.error(`No response received.`, {
							timeout: 0,
							closeOnClick: true,
						});
					} else {
						// Something happened in setting up the request that triggered an Error
						// this.submitStatus = 'Error'
						this.$snotify.error(`${error.message}`, {
							timeout: 0,
							closeOnClick: true,
						});
					}
				});
		},
		prepareNextCollection(day, month, year) {
			var daysInMonth = new Date(year, month, 0).getDate();
			if (day > daysInMonth) {
				day = 1;
				month += 1;
				if (month > 12) {
					month = 1;
					year += 1;
				}
			}
			return moment.utc(`${month}.${day}.${year}`).format();
		},
		checkBacsCalendar() {
			var date = moment.utc().format('D.M.YYYY');
			var dateComponents = date.split('.');

			if (
				moment(date).isSameOrBefore(this.currentFixedPayment.FirstCollectionDue)
			)
				return this.$store.dispatch(
					'getBacsCalendar',
					this.currentFixedPayment.FirstCollectionDue
				);

			if (this.currentFixedPayment.DaysOfMonth.length == 1) {
				if (
					this.currentFixedPayment.DaysOfMonth[0] >= parseInt(dateComponents[0])
				) {
					return this.$store.dispatch(
						'getBacsCalendar',
						this.prepareNextCollection(
							this.currentFixedPayment.DaysOfMonth[0],
							parseInt(dateComponents[1]),
							parseInt(dateComponents[2])
						)
					);
				}
				return this.$store.dispatch(
					'getBacsCalendar',
					this.prepareNextCollection(
						this.currentFixedPayment.DaysOfMonth[0],
						parseInt(dateComponents[1]) + 1,
						parseInt(dateComponents[2])
					)
				);
			}

			if (this.currentFixedPayment.DaysOfMonth.length > 1) {
				var nextDayOfMonth = _.find(
					this.currentFixedPayment.DaysOfMonth.sort((a, b) => a - b),
					function(day) {
						return day >= dateComponents[0];
					}
				);
				if (nextDayOfMonth == undefined) {
					nextDayOfMonth = _.find(
						this.currentFixedPayment.DaysOfMonth.sort((a, b) => a - b),
						function(day) {
							return day >= 1;
						}
					);
					return this.$store.dispatch(
						'getBacsCalendar',
						this.prepareNextCollection(
							nextDayOfMonth,
							parseInt(dateComponents[1]) + 1,
							dateComponents[2]
						)
					);
				}
				return this.$store.dispatch(
					'getBacsCalendar',
					this.prepareNextCollection(
						nextDayOfMonth,
						parseInt(dateComponents[1]),
						dateComponents[2]
					)
				);
			}
		},
	},
};
</script>
